"use strict";

var _$util_37 = {
  isString: function (arg) {
    return "string" == typeof arg;
  },
  isObject: function (arg) {
    return "object" == typeof arg && null !== arg;
  },
  isNull: function (arg) {
    return null === arg;
  },
  isNullOrUndefined: function (arg) {
    return null == arg;
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInV0aWwuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiaXNTdHJpbmciLCJhcmciLCJpc09iamVjdCIsImlzTnVsbCIsImlzTnVsbE9yVW5kZWZpbmVkIl0sIm1hcHBpbmdzIjoiQUFBQSxZQUFBLENBQUE7O0FBRUFBLGFBQUFBLEdBQWlCO0VBQ2ZDLFFBQUFBLEVBQVUsVUFBU0MsR0FBVCxFQUFTQTtJQUNqQixPQUF1QixRQUFBLElBQUEsT0FBVixHQUFiLENBQUE7R0FGYTtFQUlmQyxRQUFBQSxFQUFVLFVBQVNELEdBQVQsRUFBU0E7SUFDakIsT0FBdUIsUUFBQSxJQUFBLE9BQVYsR0FBVSxJQUFvQixJQUFBLEtBQVJBLEdBQW5DLENBQUE7R0FMYTtFQU9mRSxNQUFBQSxFQUFRLFVBQVNGLEdBQVQsRUFBU0E7SUFDZixPQUFlLElBQUEsS0FBUkEsR0FBUCxDQUFBO0dBUmE7RUFVZkcsaUJBQUFBLEVBQW1CLFVBQVNILEdBQVQsRUFBU0E7SUFDMUIsT0FBYyxJQUFBLElBQVBBLEdBQVAsQ0FBQTtHQUFPQTtDQVhYRixDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19